import { createApi } from "@reduxjs/toolkit/query/react";
import { createRetryingBaseQuery } from "../retryingBaseQuery";
import fetchAllPages from "../../utils/fetchAllPages";

const baseQuery = createRetryingBaseQuery("");

export const leadingZeroesAPI = createApi({
  reducerPath: "leadingZeroesAPI",
  baseQuery,
  keepUnusedDataFor: 0,
  tagTypes: ["tagGetLeadingZeroes"],
  refetchOnMountOrArgChange: true,
  refetchOnReconnect: true,
  endpoints: (builder) => ({
    //* *********************************************************** */
    //* GET LEADING ZEROES */
    getLeadingZeroes: builder.query({
      queryFn: async (body: any, _queryApi, _extraOptions, _baseQuery) =>
        fetchAllPages(
          _baseQuery,
          `${process.env.REACT_APP_LIFT_NET_CLOUD_API_ONLINE}/leading-zeroes/?&page=1&limit=500`,
          { authorization: body.token },
        ),
      providesTags: ["tagGetLeadingZeroes"],
    }),
    //* *********************************************************** */
    //* POST LEADING ZEROES */
    postLeadingZeroes: builder.mutation({
      query: (body: any) => ({
        url: `${process.env.REACT_APP_LIFT_NET_CLOUD_API_ONLINE}/leading-zeroes/`,
        method: "POST",
        body: body.body,
        headers: { authorization: body.token },
      }),
      invalidatesTags: ["tagGetLeadingZeroes"],
    }),
    //* *********************************************************** */
    //* PUT LEADING ZEROES */
    putLeadingZeroes: builder.mutation({
      query: (body: any) => ({
        url: `${process.env.REACT_APP_LIFT_NET_CLOUD_API_ONLINE}/leading-zeroes/${body.id}`,
        method: "PUT",
        body: body.body,
        headers: { authorization: body.token },
      }),
      invalidatesTags: ["tagGetLeadingZeroes"],
    }),
    //* *********************************************************** */
    //* DELETE LEADING ZEROES */
    deleteLeadingZeroes: builder.mutation({
      query: (body: any) => ({
        url: `${process.env.REACT_APP_LIFT_NET_CLOUD_API_ONLINE}/leading-zeroes/${body.id}`,
        method: "DELETE",
        headers: { authorization: body.token },
      }),
      invalidatesTags: ["tagGetLeadingZeroes"],
    }),
    //* *********************************************************** */
  }),
});

export const {
  useLazyGetLeadingZeroesQuery,
  usePostLeadingZeroesMutation,
  usePutLeadingZeroesMutation,
  useDeleteLeadingZeroesMutation,
} = leadingZeroesAPI;
